module.exports = __webpack_public_path__ + "images/145_1024.jpg";